// extracted by mini-css-extract-plugin
module.exports = {"placement":"placements-module_placement_9ef97","accordionHeader":"placements-module_accordionHeader_e0ea9"};